import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'
import type { DocumentsListResponse } from 'shared/src'
import { computed, type MaybeRef, toValue } from 'vue'

export interface DocumentsListParams {
  q?: string
  owners?: string[]
  types?: string[]
  page?: number
  pageSize?: number
}

export const documentsListQueryKey = (params: DocumentsListParams) =>
  ['documents', 'list', params] as const

export function useDocumentsListQuery(params: MaybeRef<DocumentsListParams>) {
  const queryKey = computed(() => documentsListQueryKey(toValue(params)))

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = toValue(params)
      const query: Record<string, string> = {}

      if (p.q) query.q = p.q
      if (p.owners?.length) query.owners = p.owners.join(',')
      if (p.types?.length) query.types = p.types.join(',')
      if (p.page) query.page = String(p.page)
      if (p.pageSize) query.pageSize = String(p.pageSize)

      return await fetchApi<DocumentsListResponse>({
        endpoint: '/api/documents/list',
        method: 'GET',
        query,
      })
    },
    placeholderData: keepPreviousData,
  })
}
